(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["solmire-footer"] && !Shopify.designMode) return;
  try {
    (()=>{const root=document.querySelector('[data-smi-localization]');if(!root||root.dataset.ready)return;root.dataset.ready='1';const form=root.querySelector('form');if(!form)return;const country=root.querySelector('[data-smi-country-select]');const language=root.querySelector('[data-smi-language-select]');const flag=root.querySelector('[data-smi-current-flag]');const toFlag=code=>{if(!code||code.length!==2)return'🌐';return String.fromCodePoint(...code.toUpperCase().split('').map(c=>127397+c.charCodeAt(0)))};if(country){Array.from(country.options).forEach(option=>{if(option.dataset.smiFlagged)return;option.textContent=toFlag(option.value)+' '+option.textContent;option.dataset.smiFlagged='1'});if(flag)flag.textContent=toFlag(country.value);country.addEventListener('change',()=>{if(flag)flag.textContent=toFlag(country.value);form.submit()})}if(language)language.addEventListener('change',()=>form.submit())})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["solmire-header"] && !Shopify.designMode) return;
  try {
    (()=>{
    const h=document.querySelector('[data-smi-header]');
    if(!h||h.dataset.ready)return;
    h.dataset.ready='1';
    const m=h.querySelector('.smi-mobile');
    const s=m?.querySelector('summary');
    const sizeMenu=()=>h.style.setProperty('--smi-menu-height',Math.max(0,innerHeight-h.getBoundingClientRect().bottom)+'px');
    const syncMenu=()=>{if(!m||!s)return;const open=m.hasAttribute('open');s.setAttribute('aria-expanded',open?'true':'false');s.setAttribute('aria-label',open?s.dataset.closeLabel:s.dataset.openLabel);if(open)sizeMenu()};
    const closeMenu=()=>{if(!m)return;m.removeAttribute('open');syncMenu()};
    const run=()=>{h.classList.toggle('is-scrolled',scrollY>46);if(m?.open)sizeMenu()};
    addEventListener('scroll',run,{passive:true});
    addEventListener('resize',()=>{if(innerWidth>820)closeMenu();else sizeMenu()},{passive:true});
    run();
    const cart=h.querySelector('[aria-controls="cart-drawer"]');
    const syncCart=e=>{const target=e.target;if(!(target instanceof HTMLElement)||target.id!=='cart-drawer')return;cart?.setAttribute('aria-expanded',e.type==='theme-drawer:open'?'true':'false');if(e.type==='theme-drawer:open')closeMenu()};
    document.addEventListener('theme-drawer:open',syncCart);
    document.addEventListener('theme-drawer:close',syncCart);
    if(m){m.addEventListener('toggle',syncMenu);m.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMenu));document.addEventListener('click',e=>{if(m.open&&e.target instanceof Node&&!m.contains(e.target))closeMenu()});document.addEventListener('keydown',e=>{if(e.key==='Escape'&&m.open){closeMenu();s?.focus()}});syncMenu()}
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["solmire-model-reviews-content-v1"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => document.querySelectorAll('[data-solmire-reviews]').forEach(section => {
    if (section.dataset.reviewsReady) return;
    section.dataset.reviewsReady = 'true';
    const links = [...section.querySelectorAll('[data-review-photo]')];
    const dialog = section.querySelector('dialog');
    if (!dialog || !dialog.showModal) return;
    let selected = 0;
    let opener;
    const show = index => {
      selected = (index + links.length) % links.length;
      const link = links[selected];
      const image = link.querySelector('img');
      const full = dialog.querySelector('[data-photo-full]');
      full.src = link.href;
      full.alt = image.alt;
      dialog.querySelector('[data-photo-caption]').textContent = link.parentElement.querySelector('figcaption').textContent;
      dialog.querySelector('[data-photo-position]').textContent = `${selected + 1} / ${links.length}`;
    };
    links.forEach((link,index) => link.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      opener = link;
      show(index);
      dialog.showModal();
    }));
    dialog.querySelector('[data-photo-close]').addEventListener('click', () => dialog.close());
    dialog.querySelector('[data-photo-prev]').addEventListener('click', () => show(selected - 1));
    dialog.querySelector('[data-photo-next]').addEventListener('click', () => show(selected + 1));
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight') { event.preventDefault(); show(selected + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(selected - 1); }
    });
    dialog.addEventListener('click', event => {
      const bounds = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
    });
    dialog.addEventListener('close', () => { if (opener) opener.focus({preventScroll:true}); });
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

})();
